import * as React from 'react';
import { colors } from '../../../index';

const IconAddPeople = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 32 32",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 26.75h-5.25V32h-2.5v-5.25H19v-2.5h5.25V19h2.5v5.25H32v2.5zM18.707 13.965a7.05 7.05 0 01-2.338 6.927l.131.052v2.762a9.377 9.377 0 00-4.5-1.143v-.003l-.063.001v.002C6.734 22.563 2.5 26.796 2.5 32H0c0-4.96 3.042-9.224 7.358-11.024A7.051 7.051 0 014.75 15.5a7.07 7.07 0 018.416-6.932A7.055 7.055 0 0120.046 0a7.055 7.055 0 017.047 7.047c0 2.18-.996 4.133-2.557 5.427a11.783 11.783 0 015.144 3.963h-3.365a9.398 9.398 0 00-5.767-2.362 7.103 7.103 0 01-1.841-.11zM15.5 7.047a4.552 4.552 0 004.547 4.546 4.552 4.552 0 004.546-4.546A4.552 4.552 0 0020.047 2.5 4.552 4.552 0 0015.5 7.047zm.875 8.453a4.568 4.568 0 00-4.563-4.563A4.568 4.568 0 007.25 15.5a4.568 4.568 0 004.563 4.563 4.568 4.568 0 004.562-4.563z"
  }));
};

export default IconAddPeople;